export enum SortOrder {
  AZ = 'az',
  ZA = 'za',
}
